// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1MZMN","error":"Textarea_error__2rfkU","readonly":"Textarea_readonly__37E7v","disabled":"Textarea_disabled__OOyx8"};